import { DroitApplicatifCode } from '../user'

export class MissingAccessError extends Error {
  constructor(missingDroitApplicatifCodes: DroitApplicatifCode[]) {
    super('Missing one of the following access for the connected user : ' + missingDroitApplicatifCodes.join(', '));
  }
}
